<div class="page-layout blank fullwidth p-12" fusePerfectScrollbar>
    <div class="mat-elevation-z8 mt-8 p-8 make">

        <!-- Tabs -->
        <div class="vehicle-detail-header">
            <div class="vehicle-detail-label vehicle-detail-label--active">
                <div class="vehicle-detail-label__inner">Make
                    <hr class="vehicle-detail-label__hr vehicle-detail-label__hr--active">
                </div>
            </div>
            <div class="vehicle-detail-label">
                <div class="vehicle-detail-label__inner">Model
                    <hr class="vehicle-detail-label__hr">
                </div>
            </div>
            <div class="vehicle-detail-label">
                <div class="vehicle-detail-label__inner">Year
                    <hr class="vehicle-detail-label__hr">
                </div>
            </div>
            <div class="vehicle-detail-label">
                <div class="vehicle-detail-label__inner">Variant
                    <hr class="vehicle-detail-label__hr">
                </div>
            </div>
        </div>
        <!-- End Tabs -->

        <h2 class="make-title">What's your car's make?</h2>

        <form class="search-make-form">
            <div class="search-bar-wrap">
                <input type="text" class="search-bar" placeholder="Search for make" [(ngModel)]="searchText" name="searchText" autocomplete="off" (keyup)="searchFilterType()">
                <mat-icon *ngIf="openSearch" class="search-bar-icon">search</mat-icon>
                <mat-icon *ngIf="clearSearch" class="search-bar-icon search-bar-icon--clear" (click)="clearSearchFilter()">close</mat-icon>
            </div>
        </form>

        <div class="make-list">
            <div class="make-list-sec" *ngFor="let make of makeList | filter: searchText">
                <div *ngIf="!make.make && make.title === 'Universal'" class="make-sec" (click)="selectUniversalVehicle()">
                    <mat-icon class="directions_car">directions_car</mat-icon>
                    <div class="make_name">{{ make.title }}</div>
                </div>
                <div *ngIf="make.make && make.title !== 'Universal'" class="make-sec" (click)="selectMake(make.make)">
                    <img class="make-image" src="{{ make.imageUrlPath }}" alt="{{ make.make }}" />
                    <div class="make_name">{{ make.make }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="loading">
    <div #dynamicContainers></div>
</div>
